<h6>Clients</h6>
<wc-grid #clientsGrid gridKey="clientsGrid" [context]="context"
         [showQuickSearch]="true" searchPlaceholder="Search clients..."
         [contextMenuItems]="gridMenu"
         (contextMenuAction)="onGridMenu($event)"
         (onCreate)="openAddClient()" />
